export default __webpack_public_path__ + "static/media/icon-email.0747f27b.svg";